import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { CheckIcon } from "lucide-react";
import { cn } from "@/utils/cn";
import { CheckboxProps, CheckboxVariant } from "./Checkbox.types";

const variantClasses: Record<CheckboxVariant, string> = {
    primary: "data-[state=checked]:bg-primary-500 data-[state=checked]:border-primary-500",
    secondary:
        "data-[state=checked]:bg-secondary-500 data-[state=checked]:border-secondary-500",
    success: "data-[state=checked]:bg-success-500 data-[state=checked]:border-success-500",
    danger: "data-[state=checked]:bg-danger-500 data-[state=checked]:border-danger-500",
    warning:
        "data-[state=checked]:bg-warning-500 data-[state=checked]:border-warning-500",
    neutral: "data-[state=checked]:bg-gray-500 data-[state=checked]:border-gray-500",
};

export const Checkbox: React.FC<CheckboxProps> = ({
    label,
    checked,
    onChange,
    disabled = false,
    variant = "primary",
    className,
}) => (
    <label className={cn("flex items-center space-x-2 text-md cursor-pointer", disabled && "opacity-60 cursor-not-allowed")}>
        <CheckboxPrimitive.Root
            checked={checked}
            onCheckedChange={(state) => onChange(Boolean(state))}
            disabled={disabled}
            className={cn(
                "w-5 h-5 rounded border transition-colors focus:outline-none focus:ring-2 focus:ring-primary-300",
                "border-gray-300 bg-white",
                variantClasses[variant],
                className
            )}
        >
            <CheckboxPrimitive.Indicator className="flex items-center justify-center text-white">
                <CheckIcon className="w-4 h-4" />
            </CheckboxPrimitive.Indicator>
        </CheckboxPrimitive.Root>
        {label && <span>{label}</span>}
    </label>
);